import React from 'react'
import Autosuggest from 'react-autosuggest';
import * as AutosuggestHighlightMatch from 'autosuggest-highlight/match'
import * as AutosuggestHighlightParse from 'autosuggest-highlight/parse'
import { locations } from '../../firestorter';



// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getSuggestions(value) {
  const escapedValue = escapeRegexCharacters(value.trim());

  if (escapedValue === '') {
    return [];
  }

  const regex = new RegExp(escapedValue);
  const { docs } = locations;

  const suggestions = docs.filter(location => regex.test(getSuggestionValue(location)));
  const _filteredSuggestions = suggestions.filter(s => !s.deleted)

  if (suggestions.length === 0) {
    return [
      { isAddNew: true }
    ];
  }
  else return suggestions;
}

function getSuggestionValue(suggestion) {
  if (suggestion.isAddNew) {
    return this.state.value;
  }

  return `${suggestion.data.name}`;
}

function renderSuggestion(suggestion, { query }) {
  if (suggestion.isAddNew) {

    return (
      <span>
        [+] הוסף מקום: <strong>{this.state.value}</strong>
      </span>
    );
  }
  else {
    const suggestionText = `${suggestion.data.name}`;
    const matches = AutosuggestHighlightMatch(suggestionText, query);
    const parts = AutosuggestHighlightParse(suggestionText, matches);

    return (
      <span className={'suggestion-content'}>
        <span className="name">
          {
            parts.map((part, index) => {
              const className = part.highlight ? 'highlight' : null;

              return (
                <span className={className} key={index}>{part.text}</span>
              );
            })
          }
        </span>
      </span>
    );
  }


}

export default class AutoSuggestInput extends React.Component {
  constructor() {
    super();

    this.state = {
      value: '',
      suggestions: [],
      selected: null
    };
  }

  onChange = (event, { newValue, method }) => {
    this.setState({
      value: newValue
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    const suggestions = getSuggestions(value)

    this.setState({
      suggestions: suggestions
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  async getMyLocation() {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (location) {
          resolve(location.coords)
        });
      } else {
        console.warn("Geolocation is not supported by this browser.");
        reject()
      }
    })
  }

  onSuggestionSelected = async (event, suggestionParams) => {
    let location = null
    if (suggestionParams.suggestion.isAddNew) {
      // Get location from the device or from map
      location = (this.props.locationFromMap.latitude && this.props.locationFromMap) || await this.getMyLocation()
    }

    const params = {
      name: suggestionParams.suggestion.isAddNew ? suggestionParams.suggestionValue : suggestionParams.suggestion.data.name,
      id: suggestionParams.suggestion.isAddNew ? null : suggestionParams.suggestion.id,
      isNew: !!suggestionParams.suggestion.isAddNew,
    }
    if (suggestionParams.suggestion.isAddNew) {
      params.location = {
        latitude: location.latitude,
        longitude: location.longitude
      }
    }

    this.props.onChange(params)
  }

  render() {
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: this.props.placeholder,
      value,
      onChange: this.onChange
    };

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionSelected={this.onSuggestionSelected}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue.bind(this)}
        renderSuggestion={renderSuggestion.bind(this)}
        inputProps={inputProps} />
    );
  }
}